module EEX.McEc.Controls.CertificateDialog {

    import RequestCertificateCommand = McEc.Commands.RequestCertificateCommand;

    // ReSharper disable once InconsistentNaming
    export interface UploadServerCsrAttribute extends CertificateDialogBaseAttribute {
    }

    export class UploadServerCsrModel extends CertificateDialogBaseModel<UploadServerCsrAttribute> {

        private requestCertificateCommand: RequestCertificateCommand;

        constructor(model: CertificateDialogModel, processStep: number, requestCertificateCommand: RequestCertificateCommand) {
            super(model, processStep);

            this.requestCertificateCommand = requestCertificateCommand;
        }

        public createCsr() {
            if (!this.get().canContinue) {
                const store = this.model.get().store;
                const certificateAttribute = this.model.get().certificateAttributes;
                const isServerCertificate = this.model.get().isServerCertificate;
                this.requestCertificateCommand.request(store, certificateAttribute, isServerCertificate);
                this.canComplete();
            }
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface UploadCSRAndRequestCertificateOptions extends CertificateDialogBaseOptions {
    }

    export class UploadServerCsrView extends CertificateDialogBaseView<UploadServerCsrModel> {
        model: UploadServerCsrModel;

        constructor(model: UploadServerCsrModel, target: HTMLElement, options?: UploadCSRAndRequestCertificateOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_UploadCrsServer,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_UploadCrsServer_Title
                    }));
        } 

        render() {
            super.render();
            this.model.createCsr();
            return this;
        }
    }
}